import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { registerfunction } from "./Service/Apis";
import { NavLink, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import "react-toastify/dist/ReactToastify.css";
import "./OTP.css";

const Register = () => {
 
  const [inputdata,setInputdata] = useState({
    fname:"",
    email:"",
    password:""
  });

  const navigate = useNavigate();
  
  const handleChange = (e)=>{
    const {name,value} = e.target;
    setInputdata({...inputdata,[name]:value})
  }

  const handleSubmit = async(e)=>{
    e.preventDefault();
    const {fname,email,password} = inputdata;

    if(fname === ""){
      toast.error("Enter Your Name")
    }else if(email === ""){
      toast.error("Enter Your Email")
    }else if(!email.includes("@")){
      toast.error("Enter Valid Email")
    }else if(password === ""){
      toast.error("Enter Your Password")
    }else if(password.length < 6){
      toast.error("Password Length is of Minimum 6 Characters")
    }else{
      const response = await registerfunction(inputdata);
      
      if(response.status === 200){
        setInputdata({...inputdata,fname:"",email:"",password:""});
        navigate("/login")
      }else{
        toast.error(response.response.data.error);
      }
    }
  }


  return (
    <div>
      <div className="form_data home-container-2">
        <div className="form_heading">
          <h1>
            Nice to meet, Register
          </h1>
          <p className="form_heading_tag">
            Hi, great to have an interaction with you. Please Register.
          </p>
        </div>
        <form>
          <div className="form_input">
            <label htmlFor="fname" className="form_input_name">
              Name
            </label>
            <input type="text" name="fname" id="" className="form_input_box" onChange={handleChange} placeholder='Enter your Name' />
          </div>
          <div className="form_input">
            <label htmlFor="email" className="form_input_name">
              Email
            </label>
            <input type="email" name="email" id="" className="form_input_box"  onChange={handleChange}  placeholder='Enter your Email Address' />
          </div>
          <div className="form_input">
            <label htmlFor="password" className="form_input_name">
              Password
            </label>
            <div className='two'>
              <Col sm="10">
                <Form.Control type="password" name="password" id="" className="form_input_box" onChange={handleChange} placeholder="Enter your password" />
              </Col>
            </div>
          </div>
          <button className="form_button" onClick={handleSubmit}>
            REGISTER
          </button>
          <p>
            Already registered. <NavLink to="/login">Login</NavLink>
          </p>
        </form>
      </div>
      <ToastContainer />
    </div>
  )
}

export default Register;